import { Grid } from "@mui/material";
import React from "react";
import { type DocumentIngestionPipelineFilter } from "../../../generated/graphql";
import DocScanVolumeByPipelineStatistics from "./doc-scan-volume-by-pipeline-statistics";
import OrderVolumeByCompanyStatistics from "./order-volume-by-company-statistics";
import OrderVolumeBySchemaStatistics from "./order-volume-by-schema-statistics";

const OverallStatistics = ({
  pipeline,
}: {
  readonly pipeline: DocumentIngestionPipelineFilter;
}) => {
  return (
    <Grid container spacing={1}>
      <Grid item xs={12}>
        <DocScanVolumeByPipelineStatistics />
      </Grid>
      <Grid item xs={6}>
        <OrderVolumeByCompanyStatistics pipeline={pipeline} />
      </Grid>
      <Grid item xs={6}>
        <OrderVolumeBySchemaStatistics pipeline={pipeline} />
      </Grid>
    </Grid>
  );
};

export default OverallStatistics;
